import { useDepositWithdrawAssetsDictionary } from '@/shared/api';
import { useMemo } from 'react';
import type { CardPaymentSystemConfig } from './types';

export const useCardPaymentSystems = () => {
  const {
    depositWithdrawAssetsData,
    depositWithdrawAssetsLoading,
    depositWithdrawAssetsError,
  } = useDepositWithdrawAssetsDictionary();

  const isReady = !!depositWithdrawAssetsData && !depositWithdrawAssetsLoading;

  const config = useMemo<CardPaymentSystemConfig>(() => {
    if (!isReady) return {};

    const paymentSystems =
      depositWithdrawAssetsData?.value?.withdraw?.paymentSystem;

    if (!Array.isArray(paymentSystems)) return {};

    const cards = paymentSystems.find(item => item.cards)?.cards;

    if (!Array.isArray(cards)) return {};

    const map: CardPaymentSystemConfig = {};

    for (const card of cards) {
      if (!card.icon) continue;

      for (const prefix of card.startNum ?? []) {
        map[String(prefix)] = {
          name: card.name,
          icon: card.icon,
        };
      }
    }

    return map;
  }, [depositWithdrawAssetsData, isReady]);

  return {
    data: config,
    isLoading: !isReady && !depositWithdrawAssetsError,
    isError: !!depositWithdrawAssetsError,
    error: depositWithdrawAssetsError,
  };
};
